import { Getters } from '@store/stories/types'

const getters: Getters = {
  stories: (state) => state.stories.data,
  storiesLength: (state) => state.stories.data?.length ?? null,
  storiesIsOpened: (state) => state.isOpened,
}

export default getters
